export enum DocumentStatus {
  InQueue = 'in_queue',
  InProgress = 'in_progress',
  FeedbackRequired = 'feedback_required',
  Completed = 'completed',
}
